var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5994 1.40104C10.8671 1.66882 10.8671 2.10299 10.5994 2.37078L2.37078 10.5994C2.10299 10.8671 1.66882 10.8671 1.40104 10.5994C1.13325 10.3316 1.13325 9.8974 1.40104 9.62961L9.62961 1.40104C9.8974 1.13325 10.3316 1.13325 10.5994 1.40104Z",
    fill: "#334155"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40104 1.40104C1.66882 1.13325 2.10299 1.13325 2.37078 1.40104L10.5994 9.62961C10.8671 9.8974 10.8671 10.3316 10.5994 10.5994C10.3316 10.8671 9.8974 10.8671 9.62961 10.5994L1.40104 2.37078C1.13325 2.10299 1.13325 1.66882 1.40104 1.40104Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterClose);
export default __webpack_public_path__ + "static/media/filterClose.96f8054303b7f6643e2e2f56cf4258c2.svg";
export { ForwardRef as ReactComponent };